import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
export class ModalOpcionesAsignacionComponent {
    constructor() {
        // Input
        this.title = "";
        this.contentText = "";
        this.asignarButtonText = "Asignar";
        this.reagsinarButtonText = "Reasignar";
        this.cancelButtonText = "Cancelar";
        // Output
        this.onAsignar = new EventEmitter();
        this.onReasignar = new EventEmitter();
        this.onLiberar = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.loading = false;
        this.processing = false;
        this.Asignado = false;
    }
    ngOnInit() {
    }
    /********* SHOW/HIDE *********/
    show(asignarCallback = null, reasignarCallback = null, liberarCallback = null, cancelCallback = null) {
        this.asignarCallback = asignarCallback;
        this.reasignarCallback = reasignarCallback;
        this.liberarCallback = liberarCallback;
        this.cancelCallback = cancelCallback;
        this.modalOpcionesAsignacion.show();
    }
    showWithInlineConfig(title, contentText, isAsignar, asignarCallback = null, reasignarCallback = null, liberarCallback = null, cancelCallback = null) {
        this.title = title;
        this.contentText = contentText;
        this.Asignado = isAsignar;
        this.asignarCallback = asignarCallback;
        this.reasignarCallback = reasignarCallback;
        this.liberarCallback = liberarCallback;
        this.cancelCallback = cancelCallback;
        this.modalOpcionesAsignacion.show();
    }
    hide() {
        this.modalOpcionesAsignacion.hide();
        return new Promise(resolve => {
            setTimeout(() => {
                this.processing = false;
            }, 1000);
        });
        //this.processing = false
    }
    /********* SHOW/HIDE *********/
    /********* OPERATIONS *********/
    asignar() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            if (this.asignarCallback) {
                this.asignarCallback();
            }
            console.log("Asignar");
            this.onAsignar.emit();
            yield this.hide();
        });
    }
    reasignar() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            if (this.reasignarCallback) {
                this.reasignarCallback();
            }
            console.log("Carga");
            this.onAsignar.emit();
            yield this.hide();
        });
    }
    liberar() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            if (this.liberarCallback) {
                this.liberarCallback();
            }
            console.log("Carga");
            this.onAsignar.emit();
            yield this.hide();
        });
    }
    cancel() {
        if (this.cancelCallback)
            this.cancelCallback();
        this.onCancel.emit();
        this.hide();
    }
}
